import React, {Component} from "react";
import {Button, Col, Divider, Empty, Row, Spin, Tabs, Tag, Timeline} from "antd";
import {offerApiServices} from "../../services/offer/OfferApiService";
import {ClockCircleOutlined} from "@ant-design/icons";
import currencyFormat from "../../helper/currencyFormat";

class DetailPrebooking extends Component<any, any> {
    private readonly initState!: any;

    constructor(props: any) {
        super(props);
        this.initState = {
            companyCode: "",
            prebookingCode: "",
            fetchingDetailPrebooking: false,
            dataDetailPrebooking: {},
            fetchPaymentHistory: false,
            dataPaymentHistory: [],
        }
        this.state = {...this.initState}
    }

    async componentDidMount() {
        await this.promisedSetState({
            prebookingCode: this.props.prebookingCode,
            companyCode: this.props.companyCode,
            fetchingDetailPrebooking: true,
        });

        await this.showOfferDetail();
        this.getPayment();
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.prebookingCode !== prevProps.prebookingCode) {
            await this.promisedSetState({
                prebookingCode: this.props.prebookingCode,
                companyCode: this.props.companyCode,
                fetchingDetailPrebooking: true,
            });
        }

        if (this.props.time !== prevProps.time) {
            await this.showOfferDetail();
            this.getPayment();
        }
    }

    showOfferDetail = async () => {
        await offerApiServices.getPrebookingDetail({
            prebookingCode: this.state.prebookingCode,
            companyCode: this.state.companyCode,
        }).then(async value => {
            await this.promisedSetState({
                dataDetailPrebooking: value.data.data,
                fetchingDetailPrebooking: false,
            });
        }).catch(async reason => {
            await this.promisedSetState({
                dataDetailPrebooking: {},
                fetchingDetailPrebooking: false,
            });
        });
    }

    getPayment = async () => {
        this.setState({
            fetchPaymentHistory: true,
        });

        offerApiServices.getPaymentHistoryOffer({
            offerCode: this.state.prebookingCode
        }).then(dataFetchPaymentHistory => {
            this.setState({
                fetchPaymentHistory: false,
                dataPaymentHistory: dataFetchPaymentHistory.data.data,
            });
        }).catch(e => {
            this.setState({
                fetchPaymentHistory: false,
                dataPaymentHistory: [],
            });
        });
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <div style={this.state.fetchingDetailPrebooking ? {} : {display: 'none'}} className={`spinCenter`}>
                    <Spin size="large"/>
                </div>
                <Tabs style={!this.state.fetchingDetailPrebooking ? {} : {display: 'none'}} defaultActiveKey="1">
                    <Tabs.TabPane tab="Offer" key="1">
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>Kode Prebooking:</Col>
                            <Col xs={24} xl={18}>{this.state.dataDetailPrebooking?.transaction_code}</Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>Tanggal Prebooking:</Col>
                            <Col xs={24} xl={18}>{this.state.dataDetailPrebooking?.transaction_time?.replace("T", " ")?.substring(0, 19)}</Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>Sumber:</Col>
                            <Col xs={24} xl={18}>{this.state.dataDetailPrebooking?.source}</Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>Area:</Col>
                            <Col xs={24} xl={18}>{this.state.dataDetailPrebooking?.area?.toUpperCase()}</Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>Status Prebooking:</Col>
                            <Col xs={24} xl={18}><b><Tag color="processing">{this.state.dataDetailPrebooking?.prebooking_status}</Tag></b></Col>
                        </Row>

                        <div style={this.state.dataDetailPrebooking?.offer_code ? {} : {display: 'none'}}>
                            <Row className={`pt-5`}>
                                <Col xs={24} xl={6} className={`col-grey-small-90`}>Kode Offer:</Col>
                                <Col xs={24} xl={18}>{this.state.dataDetailPrebooking?.offer_code}</Col>
                            </Row>
                            <Row className={`pt-5`}>
                                <Col xs={24} xl={6} className={`col-grey-small-90`}>Kode Deposit:</Col>
                                <Col xs={24} xl={18}>{this.state.dataDetailPrebooking?.deposit_code}</Col>
                            </Row>
                        </div>

                        <Divider/>

                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>Nama Konsumen:</Col>
                            <Col xs={24} xl={18}>{this.state.dataDetailPrebooking?.name}</Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>Phone Konsumen:</Col>
                            <Col xs={24} xl={18}>{this.state.dataDetailPrebooking?.phone_number}</Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>Nomor KTP:</Col>
                            <Col xs={24} xl={18}>{this.state.dataDetailPrebooking?.id_card_number}</Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>Gambar KTP:</Col>
                            <Col xs={24} xl={18}>
                                {this.state.dataDetailPrebooking?.id_card_image && <a target={'_blank'} rel="noreferrer" href={this.state.dataDetailPrebooking?.id_card_image}> Lihat Image </a>}
                            </Col>
                        </Row>
                        <Divider/>

                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>Kode Agen:</Col>
                            <Col xs={24} xl={18}>{this.state.dataDetailPrebooking?.agent_code}</Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>Nama Agen:</Col>
                            <Col xs={24} xl={18}>{this.state.dataDetailPrebooking?.agent_name}</Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>Tipe Agen:</Col>
                            <Col xs={24} xl={18}>{this.state.dataDetailPrebooking?.amarta_vip_type}</Col>
                        </Row>
                        <Divider/>

                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>Nilai PreBooking:</Col>
                            <Col xs={24} xl={18}>{currencyFormat(this.state.dataDetailPrebooking?.payment?.amount)}</Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>Metode:</Col>
                            <Col xs={24} xl={18}>{this.state?.dataDetailPrebooking?.payment?.channel} - {this.state?.dataDetailPrebooking?.payment?.method}</Col>
                        </Row>
                        <Divider/>

                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Data Pembayaran" key="pay">
                        <div style={this.state.fetchPaymentHistory ? {textAlign: "center", padding: 20, minHeight: 200} : {display: 'none'}}>
                            <Spin style={{marginTop: 20}} size={'large'} tip="Loading..."/>
                        </div>
                        <div style={!this.state.fetchPaymentHistory ? {} : {display: 'none'}}>
                            <div style={this.state.dataPaymentHistory.length > 0 ? {} : {display: 'none'}}>
                                <Button size={"small"} onClick={this.getPayment} type="primary"><ClockCircleOutlined/> Reload Data Pembayaran</Button> <br/> <br/> <br/>
                                <div style={{marginLeft: 20}}>
                                    <Timeline>
                                        {this.state.dataPaymentHistory.map((dt: any, x: number) =>
                                            <Timeline.Item key={x} dot={<ClockCircleOutlined style={{fontSize: '16px'}}/>}>
                                                <i style={{fontSize: "85%", color: "#59c997"}}>{dt.timestamp?.replace('T', ' ').substring(0, 16)}</i><br/>
                                                {dt.institution_type} {dt.institution_name}<br/>
                                                {currencyFormat(dt.amount)}<br/>
                                            </Timeline.Item>
                                        )}
                                    </Timeline>
                                </div>
                            </div>
                            <div style={this.state.dataPaymentHistory.length === 0 ? {} : {display: 'none'}}>
                                <Button size={"small"} onClick={this.getPayment} type="primary"><ClockCircleOutlined/> Reload Data Pembayaran</Button> <br/> <br/> <br/>
                                <Empty/>
                            </div>
                        </div>
                    </Tabs.TabPane>
                </Tabs>
            </React.Fragment>
        );
    }
}

export default DetailPrebooking;
